import { Component,Input } from '@angular/core';
import { event } from 'src/app/models/events';


@Component({
  selector: 'app-svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss'],
})
export class SvgEventIconComponent {

  @Input() evento: event = {} as event;

  constructor(
  ) {
  }

  public getFill(evento: event): string {

    switch (evento.event) {
      case 'impacto':
        return 'red';
      case 'desconexion':
        return 'white';
      case 'perdida':
        return 'orange  ';
      default:
        return 'grey';
    }
  }
}